import React from "react";
import { Grid } from "@mui/material";
import { FeedbackNavbar } from "./FeedbackNavbar";
import FeedbackForm from "./FeedbackForm";
import { Navigate, useParams } from "react-router-dom";
import { BriefId, SubscriberId, useBriefByIdQuery } from "../../app/services/subscriberFeedbackApi";
import Typography from "@mui/material/Typography";
import { isArchiveSubscriber } from "./ArchiveSubscriber";

export function HomePage() {
    const { subscriberId = "", briefId = "" }: { subscriberId?: SubscriberId; briefId?: BriefId } = useParams<
        "subscriberId" | "briefId"
    >();

    const { data: brief, error: briefError, isFetching: briefFetching } = useBriefByIdQuery(briefId);

    const hiddenDisplay = { display: "none" };

    if (briefError) {
        return <Navigate to={"/"} />;
    } else {
        return (
            <Grid container direction={"column"} data-testid={"feedback-home"}>
                <Grid item pt={10}>
                    <Typography variant={"h1"} textAlign={"center"} mb={3}>
                        {briefFetching ? "Loading..." : `Feedback for ${brief?.fullName}`}
                    </Typography>
                </Grid>
                <Grid item sx={{ ...(briefFetching && { display: hiddenDisplay }) }}>
                    {!isArchiveSubscriber(subscriberId) && <FeedbackNavbar brief={brief} subscriberId={subscriberId} />}
                </Grid>
                <Grid item pt={10} sx={{ ...(briefFetching && { display: hiddenDisplay }) }}>
                    <Grid container justifyContent="center" spacing={4} alignItems="center" height={1}>
                        <FeedbackForm briefId={briefId} subscriberId={subscriberId} />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
